import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { useParams } from "react-router-dom";
import axios from "axios";
import { loadStripe } from "@stripe/stripe-js";

const PackageDetail = () => {
  const params = useParams();
  const packageId = params.id;
  const [packageData, setPackageData] = useState(null);
  const [backgroundImages, setBackgroundImages] = useState([]);
  const [weatherData, setWeatherData] = useState(null);

  useEffect(() => {
    if (packageData && packageData.location) {
      // Fetch weather data when packageData or location changes
      fetchWeatherData(packageData.location);
    }
  }, [packageData]);

  useEffect(() => {
    const fetchBackgroundImages = async () => {
      try {
        if (packageData && packageData.location) {
          const images = await fetchImagesByLocation(packageData.location);
          setBackgroundImages(images);
        }
      } catch (error) {
        console.error("Error fetching background images:", error);
      }
    };
    fetchBackgroundImages();
  }, [packageData]);

  useEffect(() => {
    axios
      .get(`https://journey-scape-main.vercel.app/api/auth/packages/${packageId}`)
      .then((response) => {
        setPackageData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching package details:", error);
      });
  }, [packageId]);

  if (!packageData) {
    return <div>Loading...</div>; // You can show a loading spinner while waiting for package data
  }

  const handleBookNow = async (pkg) => {
    try {
      const stripe = await loadStripe(
        "pk_test_51NYCQeKoX4yf2BcDWx5A0S7Q6fbIUGmnbAQgVgqpKfFOZJeVG6gIByZbLXFmzinA9NwSPYsTSI1qTbsnc52l40s400toXeA94r"
      ); // Replace with your Stripe publishable key
      if (!stripe) {
        console.error("Stripe.js has not been loaded yet.");
        return;
      }

      const price = parseFloat(pkg.price.replace(/,/g, "")); // Convert the price string to a number

      const response = await axios.post(
        "https://stripe-backend-delta.vercel.app/create-checkout-session",
        {
          title: pkg.title,
          price: price, // Use the numeric price
          images: [`https://journey-scape-main.vercel.app/uploads/${pkg.image}`], // Pass the image URL as an array
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const { id } = response.data;

      // Redirect to Stripe Checkout
      const result = await stripe.redirectToCheckout({
        sessionId: id,
      });

      if (result.error) {
        console.error("Error redirecting to Checkout:", result.error);
      }
    } catch (error) {
      console.error("Error creating checkout session:", error);
    }
  };

  const defaultBackgroundImage =
    "https://res.cloudinary.com/dvop4v8kb/image/upload/c_fill,e_improve,w_1920,h_800/v1686503409/JheelSaifUlMalook_kwpego.jpg";

  const backgroundStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: packageData.image
      ? `url(https://journey-scape-main.vercel.app/uploads/${packageData.image})`
      : `url(${defaultBackgroundImage})`,
  };

  const fetchImagesByLocation = async (location) => {
    try {
      const apiKey = "eEEv-7Uc9AMSEJ8CYWpXF78IPuXFLVqL94UDvMqQ8GQ"; // Replace with your Unsplash API key
      const apiUrl = `https://api.unsplash.com/search/photos?query=${location}&per_page=10&orientation=landscape`; // Adjust per_page as needed

      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Client-ID ${apiKey}`,
        },
      });

      return response.data.results;
    } catch (error) {
      console.error("Error fetching images from Unsplash:", error);
      return [];
    }
  };
  

  const fetchWeatherData = async (location) => {
    try {
      // Fetch latitude and longitude from geocoding API (e.g., OpenCageData)
      const geocodingApiKey = "5b2467b30b3e402e9d3256258c09ce99";
      const geocodingApiUrl = `https://api.opencagedata.com/geocode/v1/json?q=${encodeURIComponent(location)}&key=${geocodingApiKey}`;
      const geocodingResponse = await axios.get(geocodingApiUrl);
  
      const { lat, lng } = geocodingResponse.data.results[0].geometry;
  
      // Fetch weather data from OpenWeatherMap API using the obtained latitude and longitude
      const openWeatherApiKey = "920bc6f930ed19954c02f485ef63c164";
      const openWeatherApiUrl = `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lng}&appid=${openWeatherApiKey}&units=metric`;
      const weatherResponse = await axios.get(openWeatherApiUrl);
  
      const weatherData = weatherResponse.data;
      console.log("Weather Data:", weatherData);
      
      // Update the weatherData state
    setWeatherData(weatherData);
      // Handle the weather data and update state or display on the UI
    } catch (error) {
      console.error("Error fetching weather data:", error);
    }
  };
  


  return (
    <>
      <Header />
      <main id="content" className="site-main">
        <section className="inner-banner-wrap">
          <div className="inner-baner-container" style={backgroundStyle}>
            <div className="container">
              <div className="inner-banner-content">
                <h1 className="inner-title display-4">{packageData.title}</h1>
              </div>
            </div>
          </div>
          <div className="inner-shape" />
        </section>

        <div className="package-detail">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="single-tour-inner">
                  <figure className="feature-image">
                    <div className="package-meta text-center">
                      <ul>
                        <li>
                          <i className="far fa-clock" />
                          {packageData.duration}
                        </li>
                        <li>
                          <i className="fas fa-user-friends" />
                          People: {packageData.people}
                        </li>
                        <li>
                          <i className="fas fa-map-marked-alt" />
                          {packageData.location}
                        </li>
                      </ul>
                    </div>
                  </figure>
                  <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <button
                        class="nav-link active"
                        id="nav-home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-home"
                        type="button"
                        role="tab"
                        aria-controls="nav-home"
                        aria-selected="true"
                      >
                        DESCRIPTION
                      </button>
                      <button
                        class="nav-link"
                        id="nav-profile-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-profile"
                        type="button"
                        role="tab"
                        aria-controls="nav-profile"
                        aria-selected="false"
                      >
                        PROGRAM
                      </button>
                      <button
                        class="nav-link"
                        id="nav-contact-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-contact"
                        type="button"
                        role="tab"
                        aria-controls="nav-contact"
                        aria-selected="false"
                      >
                        REVIEW
                      </button>
                      <button
                        class="nav-link"
                        id="nav-contact-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-contact"
                        type="button"
                        role="tab"
                        aria-controls="nav-contact"
                        aria-selected="false"
                      >
                        MAP
                      </button>
                    </div>
                  </nav>
                  <div class="tab-content" id="nav-tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="nav-home"
                      role="tabpanel"
                      aria-labelledby="nav-home-tab"
                      tabindex="0"
                    >
                      {packageData.description}
                    </div>
                    <div
                      class="tab-pane fade"
                      id="nav-profile"
                      role="tabpanel"
                      aria-labelledby="nav-profile-tab"
                      tabindex="0"
                    >
                      ...
                    </div>
                    <div
                      class="tab-pane fade"
                      id="nav-contact"
                      role="tabpanel"
                      aria-labelledby="nav-contact-tab"
                      tabindex="0"
                    >
                      ...
                    </div>
                    <div
                      class="tab-pane fade"
                      id="nav-disabled"
                      role="tabpanel"
                      aria-labelledby="nav-disabled-tab"
                      tabindex="0"
                    >
                      ...
                    </div>
                  </div>
                  <br />
                  <div className="single-tour-gallery">
                    <h3>GALLERY / PHOTOS</h3>
                    {/* Gallery of images */}
                    <div
                      id="carouselExampleAutoplaying"
                      className="carousel slide"
                      data-bs-ride="carousel"
                    >
                      <div className="carousel-inner">
                        {backgroundImages.map((image, index) => (
                          <div
                            key={image.id}
                            className={`carousel-item ${
                              index === 0 ? "active" : ""
                            }`}
                            style={{ height: "60vh" }}
                          >
                            <img
                              src={image.urls.regular}
                              className="d-block w-100"
                              alt={packageData.title}
                            />
                          </div>
                        ))}
                      </div>
                      <button
                        className="carousel-control-prev"
                        type="button"
                        data-bs-target="#carouselExampleAutoplaying"
                        data-bs-slide="prev"
                      >
                        <span
                          className="carousel-control-prev-icon"
                          aria-hidden="true"
                        ></span>
                        <span className="visually-hidden">Previous</span>
                      </button>
                      <button
                        className="carousel-control-next"
                        type="button"
                        data-bs-target="#carouselExampleAutoplaying"
                        data-bs-slide="next"
                      >
                        <span
                          className="carousel-control-next-icon"
                          aria-hidden="true"
                        ></span>
                        <span className="visually-hidden">Next</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="sidebar">
                  <div className="package-price">
                    <h5 className="price">
                      <span>${packageData.price}</span>
                    </h5>
                    <div className="start-wrap">
                      <div className="rating-start" title="Rated 5 out of 5">
                        <span style={{ width: "60%"}} />
                      </div>
                    </div>
                  </div>
                  <div className="btn-wrap">
                    <button style={{ width: "100%" , margin: "0px" }}
                      onClick={() => handleBookNow(packageData)}
                      className="button-text width-6"
                    >
                      Book Now
                      <i className="fas fa-arrow-right" />
                    </button>
                  </div>
                    {/* Weather Information */}
{/* Weather Information */}
                  {packageData && packageData.location && weatherData && (
                    <div className="weather-info card mt-4">
                      <h2 className="card-header display-6">
                        Weather in {packageData.location}
                      </h2>
                      <div className="card-body weather-details">
                        <div className="weather-icon">
                          <img
                            src={`http://openweathermap.org/img/w/${weatherData.weather[0].icon}.png`}
                            alt={weatherData.weather[0].description}
                          />
                        </div>
                        <div className="weather-description">
                          <p>{weatherData.weather[0].description}</p>
                        </div>
                        <div className="weather-temperature">
                          <p>Temperature: {weatherData.main.temp} °C</p>
                        </div>
                        <div className="weather-additional">
                          <p>Feels Like: {weatherData.main.feels_like} °C</p>
                          <p>Humidity: {weatherData.main.humidity}%</p>
                          <p>Wind Speed: {weatherData.wind.speed} m/s</p>
                        </div>
                      </div>
                    </div>
                  )}

                </div>
              </div>
            </div><br/><br/>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default PackageDetail;
